import React, { useEffect, useState } from "react";
import adminAccountingApi from "../services/adminAccountingApi";
import "../styles/Admin.css";

export default function AdminTrialBalancePage({ adminEmail, onLogout }) {
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  async function load() {
    setStatus({ type: "", msg: "" });
    setLoading(true);
    try {
      const res = await adminAccountingApi.getTrialBalance({
        dateFrom: dateFrom || undefined,
        dateTo: dateTo || undefined,
      });
      if (!res?.ok) throw new Error(res?.error || "load_failed");
      setRows(res.rows || []);
    } catch {
      setStatus({ type: "error", msg: "Unable to load trial balance." });
      setRows([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function money(v) {
    const n = Number(v || 0);
    return Number.isFinite(n) ? n.toFixed(2) : "0.00";
  }

  return (
    <section className="ucx-section">
      <div className="ucx-container ucx-admin-page">
        <div className="ucx-admin-header">
          <div>
            <h1 className="ucx-admin-title">Trial Balance</h1>
            <p className="ucx-admin-subtitle">Debits and credits by account</p>
          </div>

          <div className="ucx-admin-header-right">
            {adminEmail && <span className="ucx-small">Signed in as {adminEmail}</span>}
            <div className="ucx-admin-header-actions">
              <button className="ucx-btn ucx-btn-outline" type="button" onClick={load} disabled={loading}>
                {loading ? "Refreshing…" : "Refresh"}
              </button>
              {typeof onLogout === "function" ? (
                <button type="button" className="ucx-admin-btn ucx-admin-btn-reject" onClick={onLogout}>
                  Sign out
                </button>
              ) : null}
            </div>
          </div>
        </div>

      <div className="ucx-admin-panel">
          <div className="ucx-admin-panel-title">Filters</div>
          <div className="ucx-admin-filters ucx-admin-filters-inventory">
            <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} title="Date From" />
            <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} title="Date To" />
            <button className="ucx-btn ucx-btn-primary" type="button" onClick={load} disabled={loading}>
              Apply
            </button>
          </div>
          {status.type === "error" ? <div className="ucx-admin-status-error">{status.msg}</div> : null}
        </div>

      <div className="ucx-admin-table-wrapper">
          <table className="ucx-admin-table">
            <thead>
              <tr>
                <th>Code</th>
                <th>Name</th>
                <th>Type</th>
                <th>Debit</th>
                <th>Credit</th>
                <th>Debit Balance</th>
                <th>Credit Balance</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>{r.code}</td>
                  <td>{r.name}</td>
                  <td>{r.type}</td>
                  <td>{money(r.debit_total)}</td>
                  <td>{money(r.credit_total)}</td>
                  <td>{money(Math.max(Number(r.net || 0), 0))}</td>
 <td>{money(Math.max(-Number(r.net || 0), 0))}</td>
                </tr>
              ))}

              {loading && (
                <tr>
                  <td colSpan={6} className="ucx-admin-empty">
                    Loading trial balance…
                  </td>
                </tr>
              )}

              {!loading && rows.length === 0 && (
                <tr>
                  <td colSpan={6} className="ucx-admin-empty">
                    No data found for these filters.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
